import styled from 'styled-components';
import { layout } from 'src/styles/layout';
import { palette } from 'src/styles/colors';

export const WealthBuilderWrapper = styled.div`
  position: relative;
  height: auto;
  max-width: 100vw !important;
  padding-bottom: 2rem;

  @media screen and (max-width: ${layout.md}) {
    padding-top: 2rem;
    padding-bottom: 0;
  }
`

export const WealthBuilderRotatedContainer = styled.div`
  -webkit-clip-path: polygon(0 0,0 0,200% 100%,0 100%);
  clip-path: polygon(0 0,0 0,200% 100%,0 100%);

  background: linear-gradient(108.43deg, rgba(150, 52, 129, 0.9) 5.55%, rgba(45, 38, 59, 0.9) 190.68%);

  max-width: 100vw !important;
  min-height: 100%;
  background-size: cover;
  position: absolute;
  width: 100%;

  @media screen and (max-width: ${layout.md}) {
    -webkit-clip-path: polygon(0 0,0 0, 320% 100%,0 100%);
    clip-path: polygon(0 0,0 0, 320% 100%,0 100%);

    & > div {
      margin-top: 5rem;
    }
  }

  @media screen and (max-width: ${layout.xs}) {
    -webkit-clip-path: polygon(0 0,0 0, 430% 100%,0 100%);
    clip-path: polygon(0 0,0 0, 430% 100%,0 100%);
  }
`

export const WealthBuilderAlignedContainer = styled.div`
  position: relative;
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
  flex-wrap: nowrap;
  justify-content: space-around;

  & > .gatsby-image-wrapper {
    max-width: 400px;
    margin-left: -5rem;
    margin-top: -2rem;

    img {
      width: 100%;
      height: auto;
    }
  }

  @media screen and (max-width: ${layout.subxlg}) {
    & > .gatsby-image-wrapper {
      margin-top: 0rem;
      max-width: 350px;
      margin-left: -5rem;
    }
  }

  @media screen and (max-width: ${layout.lg}) {
    & > .gatsby-image-wrapper {
      margin-top: 5rem;
      max-width: 300px;
      margin-left: -5rem;
    }
  }

  @media screen and (max-width: ${layout.md}) {
    flex-wrap: wrap-reverse;

    & > .gatsby-image-wrapper {
      margin-top: -5rem;
      max-width: initial;
      margin-left: initial;

      img {
        width: 40%;
        margin: 0 auto;
      }
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    & > .gatsby-image-wrapper {
      margin-top: -2rem;

      img {
        width: 50%;
        margin: 0 auto;
      }
    }
  }
`

export const TextContainer = styled.div`
  max-width: 700px;
  margin-top: 5rem;
  position: relative;

  @media screen and (max-width: ${layout.subxlg}) {
    max-width: 600px;
    margin-top: 7rem;
    padding: 0px 2rem;
  }

  @media screen and (max-width: ${layout.lg}) {
    max-width: 500px;
    margin-top: 7rem;
    padding: 0px 2rem;
  }

  @media screen and (max-width: ${layout.md}) {
    max-width: initial;
    margin-top: initial;
    padding: 0px 2rem;
  }
`

export const WealthBuilderHeading = styled.p`
  font-family: 'Walsheim';
  font-style: normal;
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 119%;
  text-align: center;
  color: ${palette.white};
  padding: 1rem;

  @media screen and (max-width: ${layout.subxlg}) {
    font-size: 1.5rem;
  }

  @media screen and (max-width: ${layout.lg}) {
    font-size: 1.3rem;
  }
`

export const StartQuotes = styled.img`
  -moz-transform: scale(-1, 1) rotateX(-180deg);
  -webkit-transform: scale(-1, 1) rotateX(-180deg);
  -o-transform: scale(-1, 1) rotateX(-180deg);
  -ms-transform: scale(-1, 1) rotateX(-180deg);
  transform: scale(-1, 1) rotateX(-180deg);

  position: absolute;
  top: 0.8rem;
  left: -1rem;

  @media screen and (max-width: ${layout.md}) {
    top: 1.5rem;
    left: 3.5rem;
    width: 45px;
  }
`

export const EndQuotes = styled.img`
  position: absolute;
  right: 10rem;
  bottom: 5rem;

  @media screen and (max-width: ${layout.md}) {
    right: 13.5rem;
    bottom: 3rem;
    width: 45px;
  }

  @media screen and (max-width: ${layout.sm}) {
    right: 6.5rem;
    bottom: 5rem;
  }
`

export const Triangle = styled.img`
  position: absolute;
  right: -2rem;
  top: 0rem;

  @media screen and (min-width: 1600px) {
    right: -1rem;
    top: -2rem;
  }

  @media screen and (max-width: ${layout.subxlg}) {
    width: 170px;
    top: 3rem;
    right: -1rem;
  }

  @media screen and (max-width: ${layout.lg}) {
    width: 170px;
    top: 1rem;
    right: 0rem;
  }

  @media screen and (max-width: ${layout.md}) {
    width: 120px;
    top: -1rem;
    right: 11rem;
  }

  @media screen and (max-width: ${layout.subMd}) {
    top: -2rem;
    right: 9rem;
  }

  @media screen and (max-width: ${layout.sm}) {
    top: -3rem;
    right: 6rem;
  }

  @media screen and (max-width: ${layout.xs}) {
    top: -2rem;
    right: 1rem;
  }
`

export const SmallSolidTriangle = styled.img`
  position: absolute;
  top: -4rem;
  right: 5rem;

  @media screen and (max-width: ${layout.subxlg}) {
    width: 15px;
    top: -2rem;
    right: 7rem;
  }

  @media screen and (max-width: ${layout.md}) {
    top: -3rem;
    right: 15rem;
  }

  @media screen and (max-width: ${layout.subMd}) {
    top: -3rem;
    right: 13rem;
  }

  @media screen and (max-width: ${layout.sm}) {
    top: -5rem;
    right: 12rem;
  }

  @media screen and (max-width: ${layout.xs}) {
    top: -2rem;
    right: 6rem;
  }
`

export const SolidConfetti = styled.img`
  position: absolute;
  top: 5rem;
  right: 32rem;

  @media screen and (max-width: ${layout.subxlg}) {
    width: 15px;
    top: 5rem;
    right: 29rem;
  }

  @media screen and (max-width: ${layout.lg}) {
    top: 5rem;
    right: 24rem;
  }

  @media screen and (max-width: ${layout.md}) {
    top: -1rem;
    right: 40rem;
  }

  @media screen and (max-width: ${layout.subMd}) {
    top: -1rem;
    right: 35rem;
  }

  @media screen and (max-width: ${layout.sm}) {
    top: -1rem;
    right: 32rem;
  }

  @media screen and (max-width: ${layout.xs}) {
    top: -1rem;
    right: 24rem;
  }

  @media screen and (max-width: ${layout.xxs}) {
    top: -1rem;
    right: 18rem;
  }
`
